import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Layout from "layouts/DashboardManage";
import Translate from "helpers/Translate";
import { getPermissions } from "store/actions/roleAction";
import {
  MANAGE_METADATA,
  MANAGE_CLIENTS,
  MANAGE_FILE_HISTORY,
  MANAGE_DELETED_FILE,
  MANAGE_ROLES,
  MANAGE_DEPARTMENTS,
  MANAGE_USERS,
  MANAGE_AI
} from "helpers/role";
import AiChipIcon from "components/Ai/AiChipIcon";

const CARDS = [
  {
    key: "meta",
    to: "/manage/metadata",
    icon: "fas fa-scroll",
    tone: "orange",
    titleId: "manage_meta_data",
    descId: "manage_meta_data_description",
    resources: [MANAGE_METADATA]
  },
  {
    key: "roles",
    to: "/manage/roles",
    icon: "fas fa-user-lock",
    tone: "violet",
    titleId: "manage_roles",
    descId: "manage_roles_description",
    resources: [MANAGE_ROLES]
  },
  {
    key: "users",
    to: "/manage/users",
    icon: "fas fa-user",
    tone: "green",
    titleId: "manage_users",
    descId: "manage_users_description",
    resources: [MANAGE_USERS]
  },
  {
    key: "collection",
    to: "/manage/departments",
    icon: "fas fa-layer-group",
    tone: "blue",
    titleId: "manage_collections",
    descId: "manage_collections_description",
    resources: [MANAGE_DEPARTMENTS]
  },
  {
    key: "clients",
    to: "/manage/clients",
    icon: "fas fa-building",
    tone: "rose",
    titleId: "manage_clients",
    descId: "manage_clients_description",
    resources: [MANAGE_CLIENTS]
  },
  {
    key: "history",
    to: "/manage/file-history",
    icon: "fas fa-history",
    tone: "amber",
    titleId: "file_history",
    descId: "file_history_description",
    resources: [MANAGE_FILE_HISTORY]
  },
  {
    key: "ai",
    to: "/manage/ai",
    icon: "ai-chip",
    tone: "teal",
    titleId: "manage_ai",
    descId: "manage_ai_description",
    resources: [MANAGE_AI]
  },
  {
    key: "logs",
    to: "/manage/deleted-file-logs",
    icon: "fas fa-trash",
    tone: "red",
    titleId: "deleted_file_logs",
    descId: "deleted_file_logs_description",
    resources: [MANAGE_DELETED_FILE]
  },
  {
    key: "import",
    to: "/manage/imported-file-logs",
    icon: "fas fa-file-import",
    tone: "sky",
    titleId: "imported_file_logs",
    descId: "imported_file_logs_description",
    resources: null
  }
];

function Manage() {
  const dispatch = useDispatch();
  const permissions = useSelector(state => state.role.getPermissions);

  useEffect(() => {
    if (!permissions) {
      dispatch(getPermissions());
    }
  }, [permissions, dispatch]);

  const canAccess = resources => {
    if (!resources) return true;
    return (
      !!permissions && resources.every(resource => permissions.includes(resource))
    );
  };

  const visibleCards = CARDS.filter(card => canAccess(card.resources));

  return (
    <Layout>
      <div className="manage manage-hub">
        <div className="manage-hub-breadcrumb">
          <Link to="/dashboard" aria-label={Translate({ id: "home" })}>
            <i className="fas fa-home" aria-hidden="true"></i>
          </Link>
          <span className="sep">/</span>
          <span>{Translate({ id: "manage" })}</span>
        </div>

        <h1 className="title manage-hub-title">
          {Translate({ id: "manage" })}
        </h1>
        <p className="manage-hub-subtitle">
          {Translate({ id: "manage_hub_subtitle" })}
        </p>

        <div className="manage-hub-grid">
          {visibleCards.map(card => (
            <Link
              key={card.key}
              to={card.to}
              className={`manage-hub-card tone-${card.tone}`}
            >
              <span className="manage-hub-card-icon" aria-hidden="true">
                {card.icon === "ai-chip" ? (
                  <AiChipIcon className="manage-hub-ai-icon" />
                ) : (
                  <i className={card.icon}></i>
                )}
              </span>
              <span className="manage-hub-card-body">
                <span className="manage-hub-card-title">
                  {Translate({ id: card.titleId })}
                </span>
                <span className="manage-hub-card-desc">
                  {Translate({ id: card.descId })}
                </span>
              </span>
              <span className="manage-hub-card-chevron" aria-hidden="true">
                <i className="fas fa-chevron-right"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Manage;
